import { default as ButtonV2, hoc, sharedProps, buttonVariants } from './Button.jsx';

export default ButtonV2;
export { hoc, sharedProps, buttonVariants };
